module.exports = __webpack_public_path__ + "static/image/service/pc/one.jpg?50ce6d5c";